import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import axios from "axios";
import Swal from "sweetalert2";
import {Link} from "react-router-dom";
import EmailContact from "../email";
import {useSelector} from "react-redux";
import ReportSearch from "../../../widgets/ReportSearch";
import Translate from "../../../utils/utils";

const headCells = [
    {id: 'id', label: <Translate id="TABLE.ID"/>},
    {id: 'grower', label: <Translate id="TABLE.GROWER"/>},
    {id: 'inspector', label: <Translate id="TABLE.INSPECTOR"/>},
    {id: 'created_at', label: <Translate id="TABLE.DATE"/>},
    {id: 'Actions', label: <Translate id="TABLE.ACTIONS"/>},
];

export default function GrowerPlantOrders(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [inspections, setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const reportResource = new Resource('plantGrowerReport');
    const [downloads, setDownloads] = useState([]);
    const user = useSelector(store => store.auth.user);
    const [initialValues, setInitialValues] = useState({});
    const [name, setSearchTerm] = useState(queryParams.name);
    const [date, setDate] = React.useState(queryParams.date);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });

    const getDownloadLink = (inspection) => {
        const time = new Date().getTime();
        const downloading = [...downloads];
        downloading.push(time);
        setDownloads([...downloading]);
        axios.get(`${process.env.REACT_APP_API_BASE_TEST}/report/plant/grower?inspectionId=${inspection.id}&download=true`, {
            responseType: 'arraybuffer',
        }).then(response => {
            const {data} = response;
            const url = URL.createObjectURL(new Blob([data], {
                type: "application/pdf"
            }));
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = url;
            a.download = `${inspection?.order?.grower?.name}_${inspection.id}_${inspection.created_at}.pdf`
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloads(downloading.filter(t => t !== time));

        }).catch(() => {
            setDownloads(downloading.filter(t => t !== time));
            Swal.fire({
                icon: 'error',
                text: 'Failed downloading report'
            });
        })
    }

    useEffect(() => {
        const list = () => {
            setIsLoading(true);
            const resource = new Resource('plantShipment/grower');
            resource.index({
                perPage,
                page,
                name,
                date
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setInspections(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };
        list()
    }, [page, perPage]);

    const openModal = (inspection) => {
        setInitialValues({
            inspection_id: inspection.id,
            inspector: inspection?.inspector?.full_name,
            created_at: inspection.created_at,
            account_id: inspection?.order?.grower?.id,
            account_name: inspection?.order?.grower?.name,
            language_id: user.language_id || '',
            type: <Translate id="TABLE.GROWER"/>
        });

    };

    const handleNameChange = (name) => {
        setSearchTerm(name);
    }

    const handleDateChange = (date) => {
        setDate(date);
    }

    const handleChangePage = (e, page) => {
        setPage(++page);
        history.push(`?page=${page}&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };


    return (
        <div className={coreStyle.root}>
            {(isLoading || downloads.length > 0) && <LinearProgress color="secondary"/>}
            <ReportSearch handleNameChange={handleNameChange} handleDateChange={handleDateChange} onSubmit={onSearch}
                          module={"Grower"} onClear={onClearSearch}
                          disabled={isLoading} value={queryParams.name} dateTerm={queryParams.date}/>
            <Paper className={coreStyle.paper}>
                <EmailContact onCloseModal={() => setInitialValues({})} initialValues={initialValues}
                              resource={reportResource}
                />
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={isLoading ? 0 : inspections.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {inspections.map(inspection => {

                                inspection.getStatus = () => {
                                    return inspection.active === '1' ? 'active' : 'inactive';
                                };

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={inspection.id}
                                    >
                                        <TableCell>{inspection?.id}</TableCell>
                                        <TableCell>{inspection?.order?.grower?.name}</TableCell>
                                        <TableCell>{inspection?.inspector?.full_name}</TableCell>
                                        <TableCell>{inspection.created_at}</TableCell>
                                        <TableCell>
                                            <Link
                                                to={`/reports/plants/grower/view?inspectionId=${inspection.id}&grower=${window.btoa(inspection?.order?.grower?.name)}&date=${inspection.created_at}`}>
                                                <button className='button-edit-delete'>
                                                    <Translate id="TABLE.ACTIONS.VIEW"/>
                                                </button>
                                            </Link>
                                            <em className='actions-separator'>|</em>
                                            <Link to="#">
                                                <button className='button-edit-delete'
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            getDownloadLink(inspection)
                                                        }}>
                                                    <Translate id="TABLE.ACTIONS.DOWNLOAD"/>
                                                </button>
                                            </Link>
                                            {inspection?.order?.grower?.email &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <button className='button-edit-delete'
                                                        onClick={() => openModal(inspection)}>
                                                    <Translate id="TABLE.ACTIONS.EMAIL"/>
                                                </button>
                                            </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
